export default "__VITE_ASSET__$6wRwrx0__"